import { ArticleHeading2 } from '@cian/ui-kit';
import * as React from 'react';
import { plural } from '@cian/utils';
import { EStarSize, Stars } from '@cian/frontend-reviews-components';

import * as style from './style.css';
import { REVIEWS_COUNT_PLURAL } from '../../../../constants/reviews';
import { Link } from '../../../Link';

export interface IReviewsCountProps {
  reviewsCount: number;
  newbuildingName: string;
  newbuildingLink: string;
  newbuildingRatings: number;
}

export const ReviewsCount: React.FC<IReviewsCountProps> = ({
  reviewsCount,
  newbuildingName,
  newbuildingLink,
  newbuildingRatings,
}) => {
  const Heading = ArticleHeading2;

  return (
    <div data-testid="ReviewsCount" className={style['title']}>
      <Heading as="h2">
        {reviewsCount} {plural(reviewsCount, REVIEWS_COUNT_PLURAL)} о&nbsp;
        <Link inline url={newbuildingLink}>
          ЖК&nbsp;«{newbuildingName}»
        </Link>
      </Heading>

      <div className={style['rating']}>
        <Heading as="h2">{newbuildingRatings}</Heading>
        &nbsp;
        <Stars size={EStarSize.M} value={newbuildingRatings} />
      </div>
    </div>
  );
};
